import React from "react";
import { Navigate } from "react-router-dom";
import { ActionPlanListView } from '../../../amorg-common/DTOs/ActionPlanListView';
import { getActionPlansForActiveUser } from "../../../api/actionPlanClientApi";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { SingleColumnLayout } from '../../_layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { MessageCard } from "../../../designSystem/Message";
import { PageHeader } from "../../../designSystem/PageHeader";
import { P } from "../../../designSystem/typography/Body";
import { clientAccessHelper } from "../../../utils/clientAccessHelper";
import { ProtectedPageContext } from "../../_contexts/ProtectedPageContext";
import { UserPageWrapper } from "../../_pageWrappers/UserPageWrapper";
import { ActionPlanListingPageSectionTable } from "../../_components/activities/ActionPlanListingPageSectionTable";

export function UserLandingPage():JSX.Element
{
    return (
        <UserPageWrapper breadCrumbs={[{ text: 'Handleplaner', url: '' }]}>
            <PageHeader narrow headerText="Handleplaner" headerStyle="secondary-gray" />
            <SingleColumnLayout narrow>
                <UserLandingPageContent />
            </SingleColumnLayout>
        </UserPageWrapper>
    );
}

function UserLandingPageContent():JSX.Element
{
    const [actionplans, setActionplans] = React.useState<ActionPlanListView[]>([]);
    const [loading, setLoading] = React.useState(true);

    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['ViewAssignedActionPlans']);

    React.useEffect(function(){
        const getData = async () => {
            setActionplans(await getActionPlansForActiveUser());
            setLoading(false);
        }
        getData();
    }, [])

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return (
        <>
                {loading &&
                    <LoadingPageOverlay loading={loading} />
                }
                
                {!loading && 
                    <Content actionplans={actionplans} />
                }
            </>
    );
}

function Content(props:{actionplans:ActionPlanListView[]}):JSX.Element
{
    const [redirectId, setRedirectId] = React.useState('');

    if(redirectId !== '')
        return <Navigate to={`/actionplans/${redirectId}`} />

    return (
        <>
            {props.actionplans.length === 0 &&
                <MessageCard variant="info">
                    <Flex flexDirection="column" gap={16}>
                        <P>Velkommen som bruger af AMORG</P>
                    
                        <P>Du er endnu ikke tildelt handleplaner eller en rolle med AMO adgang.</P>
                    
                        <P>Hvis du mener dette er en fejl, bør du kontakte din AMO gruppe.</P>
                    </Flex>
                </MessageCard>
            }

            {props.actionplans.length > 0 &&
                <>
                    <P>Du er valgt som ansvarlig for følgende handleplaner</P>

                    <ActionPlanListingPageSectionTable
                        items={props.actionplans}
                        noContentText="Ingen handleplaner tildelt"
                        onClick={(actionPlanId) => setRedirectId(actionPlanId)}
                    />
                </>
            }
        </>
    );
}